module.exports = __webpack_public_path__ + "static/media/close.db28699a.svg";